import React,  { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Grid, Select,MenuItem, FormControl, InputLabel,Button,Typography,TextField, Menu } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import Alert from '@material-ui/lab/Alert';
import Title from './../components/Complements/Title';
import DialogOTP from '../components/Complements/DialogOTP';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import { arrayEmptyField, filterArrayEqual } from '../functions/arrays';
import { feathersCreateData, feathersFindDataAll } from '../services'
import { sendLogs } from '../functions/function-logs';
import xlsxParser from 'xlsx-parse-json';
import { history } from '../helpers/history';
import TablePayroll from '../components/Payroll/TablePayroll';
import { validatePayroll } from '../components/Payroll/validatePayroll';
import entitiesPayroll from '../components/Payroll/entities.json';
import { encrypt, decrypt } from '../functions/mobile';

const useStyles = makeStyles(theme => ({

    textTotalPayment: {
        [theme.breakpoints.up('xs')]: {
            fontSize: '110%'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '140%'
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '140%'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '140%'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '140%'
        },
    },
    logo: {
        [theme.breakpoints.up('xs')]: {
            width: `auto`,
            height: `70px`,
        },
        [theme.breakpoints.up('sm')]: {
            width: `auto`,
            height: `70px`,
        },
        [theme.breakpoints.up('md')]: {
            width: `auto`,
            height: `70px`,
        },
        [theme.breakpoints.up('lg')]: {
            width: `auto`,
            height: `70px`,
        },
        [theme.breakpoints.up('xl')]: {
            width: `auto`,
            height: `70px`
        },
        // width: '70%',
        // height: '100%'
      },
}));

const UploadPayRoleContainer = props => {

    const { handleOpenSnack, devices, company } = props

    const classestwo = useStyles();
    
    const [ loading, setLoading ] = useState(false)
    //const [ valueFile, setValueFile ] = useState("")
    const [ accountSelected, setAccountSelected ] = useState([])
    const [ allData, setAllData ] = useState([])
    const [ dataPaginate, setDataPaginate ] = useState([])
    const [ page, setPage ] = useState(1)
    const [ count, setCount ] = useState(1)
    const [ deudaTotal, setDeudaTotal ] = useState("0")
    const [ openDialogOTP, setOpenDialogOTP ] = useState(false);
    const [ conceptError, setConceptError ] = useState(false);
    const [ documentIsCorrect, setDocumentIsCorrect ] = useState(true);
    const [ initialTime, setInitialTime ] = useState(Date.now());
    const [ concept, setConcept ] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);

    const hiddenFileInput = React.useRef(null);

    const handleMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const mount = () => {
        const unmount = () => {

            // if( usersCompany.length === 0 ) { await getUsersCompany()}
            if (company.length > 0) {
                setAccountSelected(company[0])
            }

        }
        return unmount()
    }

    useEffect(mount, [company])

    const handleReadFile = (event) => {

        try{
            setLoading(true)

            if(event.target.files.length > 0){
                //setValueFile(event.target.value)
                // readFile(event.target.files[0])
                if (event.target.files[0].name.split('.')[1] ==='xlsx' ) {
                    xlsxParser
                    .onFileSelection(event.target.files[0], {  hideEmptyRows:true })
                    .then(data => {
                        let dataFilter = data.Nomina.filter((row, i) => {
                            if (
                                (row.Identificacion) &&
                                (row.NombreApellido) &&
                                (row.NumeroCuentaDestino) &&
                                (row.Valor)
                            ) {
                                return true
                            } else {
                                return false
                            }
                        })
                        dataFilter.forEach((v, i) => {
                            if (v.Institucion && v.Institucion !== 'NINGUNO') {
                                const dataIns = filterArrayEqual(data.BCC, 'value', v.Institucion)[0]
                                dataFilter[i].Cod = dataIns.code
                                dataFilter[i].TipoInstitucion = dataIns.number
                            }
                            // dataFilter[i].TipoIdentificacion = 1
                            // dataFilter[i].entity = JSON.stringify({
                            //     "value": "NINGUNO",
                            //     "number": "",
                            //     "code": ""
                            // })
                            // dataFilter[i].Institucion = 'NINGUNO'
                            // dataFilter[i].TipoInstitucion = ''
                            // dataFilter[i].Cod = ''
                        })
                        dataFilter = arrayEmptyField(dataFilter, ['Identificacion', 'NombreApellido', 'NumeroCuentaDestino', 'Valor'])
                        validatePayroll(dataFilter, setDocumentIsCorrect)
                        
                        setAllData(dataFilter)
                        getDataViewTable(dataFilter)
                        getDeudaTotal(dataFilter)
                        if(dataFilter.length === 0) { handleOpenSnack("El archivo no contiene información.", "info") }
                        setLoading(false)
                    }).catch(error => {
                        //console.log(error)
                        setLoading(false)
                        handleOpenSnack("Ha ocurrido un error al cargar el archivo. Por favor revise la plantilla.", "error")
                    })
                } else if (event.target.files[0].name.split('.')[1] ==='txt') {
                    xlsxParser
                    .onFileSelection(event.target.files[0], {  hideEmptyRows:true })
                    .then(data => {
                        let dataFilter = data.Sheet1.filter((row, i) => {
                            if (
                                (row.Identificacion) &&
                                (row.NombreApellido) &&
                                (row.NumeroCuentaDestino) &&
                                (row.Valor)
                            ) {
                                return true
                            } else {
                                return false
                            }
                        })
                        dataFilter.forEach((v, i) => {
                            if (v.Institucion && v.Institucion !== 'NINGUNO') {
                                if (isNaN(parseFloat(v.Institucion))) {
                                    const dataIns = filterArrayEqual(entitiesPayroll, 'value', v.Institucion)[0]
                                    dataFilter[i].Cod = dataIns.number
                                    dataFilter[i].TipoInstitucion = dataIns.code
                                } else {
                                    const dataIns = filterArrayEqual(entitiesPayroll, 'number', v.Institucion)[0]
                                    dataFilter[i].Cod = dataIns.number
                                    dataFilter[i].TipoInstitucion = dataIns.code
                                    dataFilter[i].Institucion = dataIns.value
                                }
                            }

                        })
                        dataFilter = arrayEmptyField(dataFilter, ['Identificacion', 'NombreApellido', 'NumeroCuentaDestino', 'Valor'])
                        validatePayroll(dataFilter, setDocumentIsCorrect)
                        
                        setAllData(dataFilter)
                        getDataViewTable(dataFilter)
                        getDeudaTotal(dataFilter)
                        if(dataFilter.length === 0) { handleOpenSnack("El archivo no contiene información.", "info") }
                        setLoading(false)
                    }).catch(error => {
                        //console.log(error)
                        setLoading(false)
                        handleOpenSnack("Ha ocurrido un error al cargar el archivo. Por favor revise la plantilla.", "error")
                    })
                } else {
                    setLoading(false)
                    handleOpenSnack("El formato de archivo debe  ser xlsx o txt.", "error")
                }
                 
            } else{
                setLoading(false)
                handleOpenSnack("Debe seleccionar un archivo.", "info")
            }

        }catch(error){
            //console.log(error)
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al cargar el archivo. Por favor revise la plantilla.", "error")
        }
    }

    const getDeudaTotal = (data) => {

        let sumatoria = 0;

        for(let i = 0; i < data.length; i++){
            sumatoria += parseFloat(data[i].Valor)
        }

        setDeudaTotal(sumatoria.toFixed(2))
    }

    const getDataViewTable = (codes) => {
        let datacodespaginate = [];
        let countaux = parseInt((codes.length / 10).toString());
        let residuo = codes.length % 10;

        if(residuo > 0){
            countaux++;
        }

        if(codes.length > 0){
            datacodespaginate = codes.slice(0, 10);
        }
        setDataPaginate(datacodespaginate)
        setCount(countaux)
        setPage(1)
    }

    const handleCleanFile = () => {
        //setValueFile("")
        setDocumentIsCorrect(true)
        setDeudaTotal("0")
        setAllData([])
        setDataPaginate([])
        setPage(0)
        setCount(0)
        setConceptError(false)
    }

    const handleAccountFind = (value) => {
        setAccountSelected(value)
        
    }

    const onChangePagination = (e, numberpage) => {
        let init = (numberpage - 1) * 10;
        let end = numberpage * 10;
        let datacodespaginate = [];
        datacodespaginate = allData.slice(init, end);
        setDataPaginate(datacodespaginate)
        setPage(numberpage)
    }

    const handleSave = async() => {

        try{
            if(allData.length > 0){
                if (concept.trim() === '' ) {
                    
                    handleOpenSnack("Ingrese un concepto para la nomina.", "info")
                    setConceptError(true)
                } else {
                    if(parseFloat(deudaTotal) > parseFloat(accountSelected.max_amount) ) {
                        handleOpenSnack(`El valor excede el monto máximo permitido por la empresa. El valor máximo es: $ ${accountSelected.max_amount}.`, 'error')
                    } else {
                        setLoading(true)

                        const { ip, mac, device } = devices
                        const sendData = encrypt(JSON.stringify({emited: 'NAVCREATECODE', type : 25, deviceData: device, ip, mac }))
                        const responseGenerateCode = await feathersCreateData("codes-recovery", { sendData })()
                        const { responseData } = responseGenerateCode
                        const jsonDecrypt = JSON.parse(decrypt(responseData))

                        const { type, alert } = jsonDecrypt;

                        if(type === 'success'){
                            setOpenDialogOTP(true)
                            setInitialTime(Date.now())
                            setLoading(false)
                        }else{
                            setLoading(false)
                            handleOpenSnack(alert, type)
                        }

                    }
                }
            }else{
                handleOpenSnack("No existen datos para enviar a guardar.", "info")
            }
        } catch (error) {
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al guardar la información. Por favor vuelva a intentar.", "error")
        }
    }

    const handleDownloadFileXLSX = () => {
        window.open(process.env.PUBLIC_URL + '/plantillaNomina.xlsx', '_blank');
        setAnchorEl(null);
    }
    const handleDownloadFileXLS = () => {
        window.open(process.env.PUBLIC_URL + '/plantillaNomina.xls', '_blank');
        setAnchorEl(null);
    }

    const handleDownloadCatalog = () => {
        window.open(process.env.PUBLIC_URL + '/CATALOGO_NOMINA.pdf', '_blank');
        setAnchorEl(null);
    }

    const handleCloseDialogOTP = () => {
        setOpenDialogOTP(false)
        //this.setState({ openDialogOTP: false })
    };

    const handleChangeInputOtp = (valueinput) => {
        if(valueinput.target.value.toString().length === 4){
            handleCompareCodeOtp({data : valueinput.target.value.toString()});
        }

    }

    const handleCompareCodeOtp = async(valuesFormOtp) => {

        setLoading(true)

        const {ip, device, mac} = devices

        const sendData = encrypt(JSON.stringify({
            ip,
            mac,
            device,
            type : 25,
            inputOtp : valuesFormOtp.data
        }))
        
        const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

        const { error, message, type, viewDialogOtp } = responseValidateCode;

        if (error === false) {

            setOpenDialogOTP(false)

            let object_send = {
                service: 'CREATE_ROLL',
                NumeroCuentaOrigen : accountSelected.number_account,
                nomina : allData,
                concept,
                otp : valuesFormOtp.data,
                ip,
                device,
                mac
            }
    
            const response = await feathersCreateData("payrolls-control", object_send)()
            setLoading(false)
            if (response.error) {
                handleOpenSnack(response.message, 'error');
            } else {
                history.push('/login')
                handleOpenSnack(response.message, 'success');
            }

        }else{

            handleOpenSnack(message, type);

            if(viewDialogOtp === false){
                setOpenDialogOTP(false)
            }

            setLoading(false)
        }

/*         feathersCreateData('otp-validates', {
            otp: valuesFormOtp.data,
            type: 25,
            user: user.vusk
        })().then(async res => {
            if (res.type === 'success') {
                setOpenDialogOTP(false)
                const { ip } = devices
                let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
                let mac = 'NAVEGADOR'
                if (!isEmpty(devices)) {
                    // const { device, ip: ipDevice, mac: macDevice } = devices
                    const { ip: ipDevice, mac: macDevice } = devices
                    // deviceData = device;
                    ipSend = ipDevice;
                    mac = macDevice;
                } 
                let object_send = {
                    service: 'CREATE_ROLL',
                    cedule : accountSelected.cedule,
                    accountSequential : accountSelected.account_sequential,
                    originAccount : accountSelected.number_account,
                    nomina : allData,
                    concept,
                    otp : valuesFormOtp.data,
                    daily: quotas[0].daily,
                    monthly: quotas[0].monthly,
                    totalAmount: deudaTotal,
                    ip: ipSend,
                    device: `${osName} ${osVersion}`,
                    mac
                }
        
                const response = await feathersCreateData("payrolls-control", object_send)()
                if (response.error) {
                    handleOpenSnack(response.message, 'error');
                } else {
                    history.push('/login')
                    handleOpenSnack(response.message, 'success');
                }
    
                
            } else {
                handleValidateAttemptsOtp(valuesFormOtp.data)
                setLoading(false)
                handleOpenSnack('Código no valido. Por favor vuelva a intentar.', 'error');
            }
            setLoading(false)
        }).catch( err => {
            setLoading(false)
            handleOpenSnack(err.message, err.type)
            handleValidateAttemptsOtp('ACADEMY_PROCESS')
        }) */
    }

    const handleUploadFile = async () => {
        try {
            const transferInProgressExist = await feathersFindDataAll('payrolls-tray', { company: accountSelected.id, state: 1})().then(res => res.length > 0 ? true: false).catch(()=> true)
            //console.log('transferInProgressExist', transferInProgressExist,{ company: accountSelected.id, state: 1} )
            if (transferInProgressExist) {
                handleOpenSnack('Ya existe una nomina pendiente en curso.', 'error');
            } else {
                // const { pay_type } = accountSelected.company
                handleCleanFile()
                setDocumentIsCorrect(true)
                hiddenFileInput.current.value = ""
                hiddenFileInput.current.click()
                // if (pay_type === 'MENSUAL') {
                //     const transferMensual = await feathersFindDataAll('payrolls-tray', { company: accountSelected.company.id, state: 2, updatedAt: { $gte: new Date(moment().startOf('month')), $lte: new Date(moment().endOf('month')) }})().then(res => res.length > 0 ? true: false).catch(()=> true)
                //     if (transferMensual) {
                //         handleOpenSnack('Ya se ha realizado el pago de la nomina en este mes.', 'info');
                //     } else {
                //         handleCleanFile()
                //         setDocumentIsCorrect(true)
                //         hiddenFileInput.current.value = ""
                //         hiddenFileInput.current.click()
                //     }
                // } else {
                //     const transferQuincenal = await feathersFindDataAll('payrolls-tray', { company: accountSelected.company.id, state: 2, updatedAt: { $gte: new Date(moment().startOf('month')), $lte: new Date(moment().endOf('month')) }})().then(res => res.length >=2  ? true: false).catch(()=> true)
                //     if (transferQuincenal) {
                //         handleOpenSnack('Ya se ha completado el pago quincenal de la nomina en este mes.', 'info');
                //     } else {
                //         handleCleanFile()
                //         setDocumentIsCorrect(true)
                //         hiddenFileInput.current.value = ""
                //         hiddenFileInput.current.click()
                //     }
                // }
                
            }
           
        } catch (error) {
            handleOpenSnack('no se ha podido realizar la subida del archivo.', 'error');
            //console.log(error)
        }
    }

    const renderBody = () => {
        try {
            return <Grid container spacing={3} alignItems="center"  justify="center" direction="row">
                    <Grid item xs={12} md={12} lg = {12} sm = {12}>
                        <Title>Nómina</Title>
                    </Grid>
                    <Grid item xs={12} md={7} lg = {7} sm = {12}>
                        <FormControl variant="outlined" style={{maxWidth: '100%'}}>
                            <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                            <Select
                            label="Seleccione una Cuenta"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            defaultValue={company[0]}
                            onChange={(e) => handleAccountFind(e.target.value) }
                            >
                                {
                                    company.map(option => {
                                    return <MenuItem key={option.id} value={option}>{`${option.name} - ${option.number_account}`}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={5} lg = {5} sm = {12}>
                        <FormControl variant="outlined" style={{minWidth: '100%'}}>
                            <Grid container spacing={3}  alignItems="center"  justify="center" direction="row">
                                <Grid item xs={6} md={6} lg = {6} sm = {6}>
                                    <input 
                                        type="file"
                                        ref={hiddenFileInput} 
                                        name="files" 
                                        accept=".xlsx, .txt"
                                        onChange = { handleReadFile }
                                        //value = { valueFile }
                                        onClick = { handleCleanFile }
                                        style={{ display: "none" }}
                                    />
                                    <Button  onClick={ handleUploadFile } ><img src={'./../../../icons/nomina/Subir Archivos.png'} alt="Logo" className={classestwo.logo}  /></Button>
                                </Grid>
                                <Grid item xs={6} md={6} lg = {6} sm = {6}>
                                    <Button  onClick = { handleMenu }><img src={'./../../../icons/nomina/Descargar Plantilla.png'} alt="Logo" className={classestwo.logo}  />
                                    </Button>
                                    <Menu
                                            id="menu-appbar"
                                            anchorEl={anchorEl}
                                            anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                            }}
                                            keepMounted
                                            transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                            }}
                                            open={Boolean(anchorEl)}
                                            onClose={handleClose}
                                        >
                                            <MenuItem onClick={handleDownloadFileXLSX}>Archivo XLSX</MenuItem>
                                            <MenuItem onClick={handleDownloadFileXLS}>Archivo XLS</MenuItem>
                                            <MenuItem onClick={handleDownloadCatalog}>Catálogo</MenuItem>
                                        </Menu>
                                </Grid>
                            </Grid>
                        </FormControl>
                    </Grid>
                    {
                        allData.length > 0 ?
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12} lg = {12} sm = {12}>
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    name={'concept'}
                                    inputProps = {
                                        {style: { 'textTransform': 'uppercase'}, maxLength: 20}
                                    }
                                    label={'Concepto'}
                                    onChange = { (ev) => {
                                        if (ev.target.value !== '') {setConceptError(false)}  else {setConceptError(true)} 
                                        setConcept(ev.target.value.toUpperCase()) 
                                    }}
                                    // ref={withFocus && (txt => { this.txt = txt;} ) }
                                    error = { conceptError }
                                />
                            </Grid>
                            <Grid item xs={12} md={12} lg = {12} sm = {12}>
                                <Typography variant="h5" color="textSecondary" align="right" className = {classestwo.textTotalPayment}>
                                    Total a pagar: $ { deudaTotal }
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={12} lg = {12} sm = {12}>
                                <TablePayroll  dataPaginate = {dataPaginate} count = {count} page = {page} onChangePagination = {onChangePagination} setDataPaginate = {setDataPaginate} setDocumentIsCorrect = {setDocumentIsCorrect} /> 
                            </Grid>
                            <Grid item xs={12} md={4} lg = {4} sm = {12}>
                                <Button variant="contained" fullWidth color = {"primary"} onClick = { handleSave } disabled = {!documentIsCorrect} >Guardar</Button>
                            </Grid>
                            <Grid item xs={12} md={4} lg = {4} sm = {12}>
                                <Button variant="contained" fullWidth color = {"primary"} onClick = { handleCleanFile }>Limpiar</Button>
                            </Grid>
                        </Grid> :
                        <Grid item xs={12} md={12} lg = {12} sm = {12}>
                            <Alert severity="info">No se ha cargado ninguna información.</Alert>
                        </Grid>
                    }
                </Grid>
        } catch (error) {
            //console.log(error)
        }
        
    }
    return (
        <div>
            <Dashboard
                title= "Dashboard"
                body = { renderBody() }
                //info = { renderBody() }
                multiple = { false }
                //panel = { 2 }
            />
            <LoadingScreen open={loading} />
            <DialogOTP
                openDialogOTP = {openDialogOTP}
                loading = { loading }
                initialTime = {initialTime}
                showQR = {false}
                onCloseDialogOTP = { handleCloseDialogOTP }
                onKeyPress = { handleChangeInputOtp }
                OTPSubmit = { handleCompareCodeOtp }
            />
        </div>
    )
}

export default connect(null, {sendLogs} )(UploadPayRoleContainer);
